var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsFrameworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20.76V5.395a2.238 2.238 0 0 1 2.236-2.24h1.94a.746.746 0 0 1 0 1.493h-1.94a.746.746 0 0 0-.745.747V20.76c0 .412.334.746.745.746h14.528a.746.746 0 0 0 .745-.746V5.394a.746.746 0 0 0-.745-.747h-1.696a.746.746 0 0 1 0-1.493h1.696a2.238 2.238 0 0 1 2.236 2.24V20.76A2.238 2.238 0 0 1 19.264 23H4.736A2.238 2.238 0 0 1 2.5 20.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.467 3.24a.746.746 0 0 0-.745-.747h-3.445a.746.746 0 0 0-.745.746v.614c0 .412.334.747.745.747h3.445a.746.746 0 0 0 .745-.746v-.615Zm1.491.614a2.238 2.238 0 0 1-2.236 2.24h-3.445a2.239 2.239 0 0 1-2.236-2.241v-.614A2.238 2.238 0 0 1 10.277 1h3.445a2.238 2.238 0 0 1 2.236 2.24v.614Zm-.893 6.01a.748.748 0 0 1 1.058-.035.751.751 0 0 1 .035 1.06l-4.904 5.247a.748.748 0 0 1-1.087.006l-2.318-2.42a.751.751 0 0 1 1.082-1.039l1.77 1.85 4.364-4.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsFrameworks);
export default __webpack_public_path__ + "static/media/sidebar-icons-frameworks.a71925408db005d4036381457eb3c2ca.svg";
export { ForwardRef as ReactComponent };